/** Wrap a value as a successful Result. */
export const ok = (value) => ({ ok: true, value });
/** Wrap a reason as a failed Result. */
export const err = (error) => ({ ok: false, error });
/**
 * Apply `f` to the value inside a successful Result; pass failures through.
 * mapResult : Result<A> (A -> B) -> Result<B>
 */
export const mapResult = (r, f) => r.ok ? ok(f(r.value)) : r;
/**
 * Chain a Result-producing step onto a Result; pass failures through.
 * flatMapResult : Result<A> (A -> Result<B>) -> Result<B>
 */
export const flatMapResult = (r, f) => r.ok ? f(r.value) : r;
/**
 * Collect a list of Results into a Result of list, failing on the first error.
 * The error is prefixed with the failing index so callers can locate bad input.
 * allResults : [Result<T>] -> Result<[T]>
 */
export function allResults(rs) {
    const out = [];
    for (let i = 0; i < rs.length; i++) {
        const r = rs[i];
        if (!r.ok)
            return err(`[${i}] ${r.error}`);
        out.push(r.value);
    }
    return ok(out);
}
/** Return the value of a successful Result, or `fallback` for a failed one. */
export const orElse = (r, fallback) => (r.ok ? r.value : fallback);
/**
 * Return the value of a successful Result, or throw. Use ONLY at trust
 * boundaries we control (tests, seed data we generated ourselves) — never on
 * input that came from a user or the network.
 */
export function expect(r, context) {
    if (r.ok)
        return r.value;
    throw new Error(`${context}: ${r.error}`);
}
//# sourceMappingURL=result.js.map